import type { FulfilmentActivityType } from "./FulfilmentActivityType";
import type { OwnerApp } from "./OwnerApp";

export enum ActivitySource {
    FRONTEND = "FRONTEND",
    HERMES = "HERMES",
    TAX_TINDER = "TAX_TINDER",
}
export interface FulfilmentActivityDto {
    id: string;
    isDone?: boolean;
    notes?: string;
    operator?: { givenName: string; familyName: string };
    source: ActivitySource;
    timestamp: string;
    title: string;
    type: FulfilmentActivityType;
    ownerApp: OwnerApp;
}
